<template>
  <div>
    <compWrapper
      :title="
        $t('global.common.base_information', { defaultValue: '基本信息' })
      "
      theme="info"
    >
      <compFormQuery
        v-if="isQuery"
        class="margin-layout"
        :formdata="getBase"
        :value="formData"
      ></compFormQuery>
      <compFormEdit
        v-else
        ref="formbase"
        class="margin-layout"
        :formdata="getBase"
        v-model="formData"
      ></compFormEdit>
      <vButtonGroup slot="footer" v-if="Query">
        <vButton v-if="!isQuery" theme="primary" @click="submitSave">{{
          $t("global.common.save", { defaultValue: "保存" })
        }}</vButton>
        <vButton
          v-if="!isQuery && getId"
          theme="error"
          @click="submitSave('complete')"
          >{{ $t("global.common.finish", { defaultValue: "完成" }) }}</vButton
        >
        <vButton @click="cancel">{{
          $t("global.common.return", { defaultValue: "返回" })
        }}</vButton>
      </vButtonGroup>
    </compWrapper>
    <compWrapper
      :title="
        $t('fbb.alloment.inbound_order_detail', {
          defaultValue: '调拨计划入库明细',
        })
      "
      theme="primary"
      v-if="!isQuery && getId"
    >
      <div class="text-right margin-10 margin-right-15">
        <vButton theme="primary" @click="handleModal('boxing')">{{
          $t("fbb.alloment.query_box_detail", { defaultValue: "查看装箱明细" })
        }}</vButton>
      </div>
      <vTableSimple
        class="margin-layout"
        :columns="getProcuctColumns"
        :data="productList"
      ></vTableSimple>
    </compWrapper>
    <compWrapper
      :title="$t('fbb.alloment.inbound_detail', { defaultValue: '入库明细' })"
      theme="primary"
      v-if="getId"
    >
      <template v-if="type !== 'query'">
        <vAlert theme="info" class="margin-layout">{{
          $t("fbb.alloment.tip_4", {
            defaultValue:
              "若存在箱码数据，可只填写箱码；若无箱码数据，则需填写ERP SKU及数量",
          })
        }}</vAlert>
        <vButtonGroup class="margin-layout">
          <vButton theme="primary" @click="onceSubmit">{{
            $t("fbb.alloment.click_inbound", { defaultValue: "一键入库" })
          }}</vButton>
          <vButton theme="info" @click="handleModal('upload')">{{
            $t("fbb.alloment.import_inbound_detail", {
              defaultValue: "导入入库明细",
            })
          }}</vButton>
        </vButtonGroup>
        <compFormEdit
          ref="bound"
          class="margin-layout"
          :formdata="getInbound"
          v-model="boundFormData"
        ></compFormEdit>
        <vButtonGroup class="margin-layout">
          <vButton theme="primary" @click="addItem">{{
            $t("fbb.alloment.add_by_one", { defaultValue: "逐个添加" })
          }}</vButton>
          <vButton theme="gray" @click="removeItems">{{
            $t("fbb.alloment.delete_data", { defaultValue: "删除数据" })
          }}</vButton>
          <vButton theme="gray" @click="clearAll">{{
            $t("fbb.alloment.clear_data", { defaultValue: "清空数据" })
          }}</vButton>
        </vButtonGroup>
      </template>
      <vTableSimple
        class="margin-layout"
        :columns="getInColumns"
        :data="dataList"
        @on-check-change="setCheckData"
      ></vTableSimple>
    </compWrapper>
    <compLog
      v-if="isQuery"
      wrapper
      :data="logList"
      :opActionMap="getLogActionMap"
    ></compLog>
    <vButtonGroup class="text-right" v-if="isQuery && !Query">
      <!-- <vButton v-if="type ==='query' && formData.errorCode!==0" class="margin-right-15" theme="success" @click="reprocess">重处理</vButton>
 			<vButton v-if="type ==='query' && formData.errorCode!==0" class="margin-right-15" theme="info" @click="backToNormal">忽略异常</vButton> -->
      <vButton @click="cancel">{{
        $t("global.common.return", { defaultValue: "返回" })
      }}</vButton>
    </vButtonGroup>
    <vModal
      v-model="modalProps.show"
      :title="modalProps.title"
      :width="modalProps.width || 1000"
      :showFooter="false"
    >
      <component
        :is="modalProps.component"
        @on-close="modalProps.show = false"
        v-on="modalProps.on"
        v-bind="modalProps.props"
      ></component>
    </vModal>
    <compModal
      v-model="modalProps2.show"
      v-bind="modalProps2"
      @on-close="modalProps2.show = false"
    >
      <component
        v-if="modalProps2.component"
        :is="modalProps2.component"
        v-bind="modalProps2.props"
        v-on="modalProps2.on"
      />
    </compModal>
    <vLoading size="large" transfer :loading="loading"></vLoading>
  </div>
</template>

<script>
import {
  HttpSaveInbound,
  HttpRemoveInbound,
  HttpClearInbound,
  HttpSubmitInbound,
  HttpInbound,
  HttpAddInbound,
  HttpInboundErpSku,
  HttpOnceInbound,
  HttpImportInbound,
  HttpDowloadInboundTemplate,
  HttpPlanBill,
} from "@/service/allotment";
import mixin from "../mixin";
import compAllotlist from "../allotlist";
import { mapGetters } from "vuex";
export default {
  mixins: [mixin],
  props: ["activeid"],
  components: {
    compWrapper: () => import("@components/templates/wrapper"),
    compFormQuery: () => import("@components/templates/formquery"),
    compFormEdit: () => import("@components/templates/formedit"),
    compLog: () => import("@components/templates/log"),
    compUpload: () => import("@components/templates/upload"),
    compAllotlist,
  },
  data() {
    return {
      loading: false,
      logList: [],
      type: this.$route.params.type,
      id: this.$route.query.id,
      formData: {},
      boundFormData: {},
      dataList: [], //入库明细,
      productList: [], //产品明细,
      boxingList: [], //装箱明细,
      checkData: [],
      modalProps: {
        show: false,
        title: this.$t("fbb.alloment.import_data", {
          defaultValue: "导入数据",
        }),
        component: "",
        width: 1000,
        props: {},
        on: {},
      },
      modalProps2: {
        show: false,
        component: "",
        width: 600,
        props: {},
        on: {},
      },
    };
  },
  created() {
    if (this.activeid) {
      /* this.$route.name = "allotUpdateManage"; */
      this.id = this.activeid;
      this.type = "query";
      this.$route.params.type = "query";
      this.$route.query.id = this.activeid;
    }
    this.getDetail();
  },
  computed: {
    ...mapGetters("dictionary", ["getBillcusWareList", "getCusAccountList"]),
    isQuery() {
      if (this.activeid || this.type === "query") {
        return true;
      } else {
        return false;
      }
      /* return this.type === 'query' */
    },
    getId() {
      return this.formData.id || this.id;
    },
    Query() {
      if (this.activeid) {
        return false;
      } else {
        return true;
      }
    },
    getBillStatus() {
      // DRAFT(0, "草稿"),
      //     APPOINTMENT(5, "已预约"),
      //     COMPLETED(70, "已完成"),
      //     CLOSED(90, "已关闭");
      return [
        {
          label: this.$t("fbb.alloment.draft", { defaultValue: "草稿" }),
          value: 0,
        },
        {
          label: this.$t("fbb.alloment.has_appointed", {
            defaultValue: "已预约",
          }),
          value: 5,
          theme: "info",
        },
        {
          label: this.$t("global.common.finished", { defaultValue: "已完成" }),
          value: 70,
          theme: "success",
        },
        {
          label: this.$t("global.common.canceled", { defaultValue: "已取消" }),
          value: 90,
          theme: "error",
        },
      ];
    },
    getBase() {
      const formData = this.formData,
        show = !!this.getId;
      return [
        {
          label: this.$t("fbb.alloment.inbound_order_number", {
            defaultValue: "调拨入库单号",
          }),
          key: "transferInboundOrderNo",
          query: true,
          show: show,
          render: (h) => {
            const { transferInboundOrderStatus, transferInboundOrderNo } =
              this.formData;
            const data =
              this.getBillStatus.find(
                (item) => item.value === transferInboundOrderStatus
              ) || {};
            return (
              <div>
                {this.formData.transferInboundOrderNo}
                <vButton
                  ghost
                  theme={data.theme}
                  style="margin-left:5px;padding:1px 10px;cursor:unset;"
                >
                  {data.label}
                </vButton>
              </div>
            );
          },
        },
        // {
        // 	label: "状态",
        // 	key: "transferInboundOrderStatus",
        // 	query: true,
        // 	show: show,
        // 	options: this.getBillStatus
        // },
        {
          label: this.$t("fbb.alloment.alloment_order_number", {
            defaultValue: "调拨计划单号",
          }),
          tag: "vInput",
          key: "transferOutboundPlanNo",
          query: show,
          props: {
            suffix: "search",
            readonly: true,
          },
          on: {
            "on-icon-click": () => this.handleModal("subTransferPlan"),
          },
        },
        // {
        // 	label: "项目",
        // 	key: "lineName",
        // 	show: this.isQuery,
        // },
        {
          label: this.$t("fbb.alloment.warehouse_in", {
            defaultValue: "入库仓库",
          }),
          query: true,
          key: "orgWarehouseCode",
          // options: formData.orgWarehouseId === undefined ? null : this.getBillcusWareList
          // valueText: formData.inOrgWarehouseCode ? `${formData.inOrgWarehouseCode}(${formData.inwarehouseTitle})` : ''
        },
        {
          label: this.$t("fbb.alloment.onsite_channel", {
            defaultValue: "ONSITE仓渠道",
          }),
          query: true,
          key: "onsiteChannel",
          // tag:'vSelect',
          // options:this.getCusAccountList,
          // options: formData.orgWarehouseId === undefined ? null : this.getWarehouseAllList
          // valueText: formData.orgWarehouseCode ? `${formData.orgWarehouseCode}(${formData.orgWarehouseTitle})` : ''
        },
        {
          label: this.$t("", {
            defaultValue: "贴标数",
          }),
          tag: "vInputNumber",
          key: "labelQty",
          required: false,
          props: {
            min: 0,
            math: "floor",
          },
        },
        {
          label: this.$t("global.common.notes", { defaultValue: "备注" }),
          tag: "vTextarea",
          key: "remark",
          required: false,
        },
      ];
    },
    getInbound() {
      const hasBoxBarcode = !!this.boundFormData.boxBarcode,
        sku = this.boundFormData.sku,
        { qty = 0, qtyInbound = 0 } =
          this.productList.find((item) => this.boundFormData.sku == item.sku) ||
          {};
      return [
        {
          label: "ERP SKU",
          key: "sku",
          tag: "vSelect",
          props: {
            filterable: true,
          },
          options: this.productList.map((item) => item.sku),
          on: {
            "on-change": (val) => {
              // const data = this.productList.find(item => item.sku == val);
              this.boundFormData = { sku: val };
            },
          },
          required: !hasBoxBarcode,
        },
        {
          label: this.$t("fbb.inbound.inventory_type", {
            defaultValue: "库存类型",
          }),
          key: "inventoryType",
          tag: "vSelect",
          options: this.getInventoryType,
        },
        {
          label: this.$t("fbb.alloment.inbound_number", {
            defaultValue: "入库数量",
          }),
          key: "qty",
          tag: "vInputNumber",
          required: !hasBoxBarcode,
          on: {
            "on-change": (val) => {
              if (val > qty - qtyInbound)
                this.$VMessage.warning(
                  this.$t("fbb.alloment.inbound_number_not_allow", {
                    defaultValue: "入库的数量不符",
                  })
                );
            },
          },
        },
        {
          label: this.$t("fbb.inbound.case_code", { defaultValue: "箱码" }),
          key: "boxBarcode",
          required: false,
        },
        {
          label: this.$t("fbb.alloment.tray_bar_code", {
            defaultValue: "托盘码",
          }),
          key: "trayBarcode",
          required: false,
        },
        {
          label: "Tracking  NO",
          key: "trackingNo",
          required: false,
        },
        {
          // label: "计划数/已入数",
          label: `${this.$t("fbb.alloment.plan_qty", {
            defaultValue: "计划数",
          })}/${this.$t("fbb.alloment.has_inbound_number", {
            defaultValue: "已入数",
          })}`,
          query: true,
          valueText: qty ? `${qty}/${qtyInbound}` : "-",
        },
      ];
    },
    getProcuctColumns() {
      return [
        {
          type: "index",
          width: 40,
          align: "center",
        },
        {
          title: "ERP SKU",
          key: "sku",
        },
        {
          title: this.$t("fbb.alloment.plan_inbound_number", {
            defaultValue: "计划入库数量",
          }),
          key: "qty",
          /* key: 'qtyOutbound', */
        },
        {
          title: this.$t("fbb.alloment.box_number", {
            defaultValue: "装箱数量",
          }),
          key: "qtyPacked",
        },
        {
          title: this.$t("fbb.alloment.has_inbound_number_1", {
            defaultValue: "已入库数量",
          }),
          key: "qtyInbound",
        },
      ];
    },
    getInColumns() {
      return [
        {
          type: "selection",
          width: this.type === "query" ? 0 : 40,
          align: "center",
          formName: "id",
        },
        {
          title: "#",
          type: "index",
          width: 40,
          align: "center",
        },
        {
          title: "Tracking  NO",
          key: "trackingNo",
        },
        {
          title: this.$t("fbb.inbound.case_code", { defaultValue: "箱码" }),
          key: "cartonBarcode",
        },
        {
          title: "ERP SKU",
          key: "sku",
        },
        {
          title: this.$t("fbb.alloment.inbound_number", {
            defaultValue: "入库数量",
          }),
          key: "qty",
        },
        {
          title: this.$t("fbb.alloment.tray_bar_code", {
            defaultValue: "托盘码",
          }),
          key: "palletBarcode",
        },
        {
          title: this.$t("fbb.inbound.inventory_type", {
            defaultValue: "库存类型",
          }),
          key: "inventoryType",
          render: (h, { row }) => {
            const data =
              this.getInventoryType.find(
                (item) => row.inventoryType == item.value
              ) || {};
            return data.label;
          },
        },
        {
          title: this.$t("global.common.createdtime", {
            defaultValue: "创建时间",
          }),
          key: "createdAt",
        },
      ];
    },
  },
  methods: {
    //获取选中入库数据
    setCheckData(rows, val) {
      this.checkData = val;
    },
    // 详情操作
    handleModal(type) {
      //装箱明细
      if (type === "boxing") {
        this.modalProps = {
          show: true,
          title: this.$t("fbb.alloment.box_detail", {
            defaultValue: "装箱明细",
          }),
          component: "vTableSimple",
          props: {
            columns: this.getBoxingColumns,
            data: this.boxingList,
          },
        };
        return;
      }
      //导入入库明细
      if (type === "upload") {
        this.modalProps = {
          show: true,
          title: this.$t("fbb.alloment.import_data", {
            defaultValue: "导入数据",
          }),
          component: "compUpload",
          width: 520,
          props: {
            ajaxRequest: HttpImportInbound,
            name: "multipartFile",
            data: {
              transferOutboundPlanId: this.formData.transferOutboundPlanId,
              transferInboundOrderId: this.getId,
            },
            download: () => {
              this.handleWebfs(
                "/static/template/Transfer_Inbound_Items.xlsx",
                {},
                {
                  executor: "download",
                  type: "url",
                }
              );
              // this.handleWebfs(process.env.VUE_APP_APIURL_FBB+"/api/v2/TransferInbound/transferInboundOrderItemTemplate", {}, 'download');
            },
          },
          on: {
            "on-success": () => {
              this.modalProps.show = false;
              this.getDetail();
            },
          },
        };
        return;
      }
      //选择调拨计划单
      if (type === "subTransferPlan") {
        this.modalProps = {
          show: true,
          title: this.$t("fbb.alloment.alloment_order_number", {
            defaultValue: "调拨计划单号",
          }),
          component: "compAllotlist",
          props: {
            initFormData: {
              "search[IN_subTransferPlanStatus]": "20,25",
            },
          },
          on: {
            "on-data": (row) => {
              this.formData = {
                ...this.formData,
                subTransferPlanId: row.id,
                transferOutboundPlanNo: row.subTransferPlanNo,
                orgWarehouseId: row.orgWarehouseId,
                orgWarehouseCode: row.orgWarehouseCode,
                onsiteChannel: row.onsiteChannel,
              };
              this.productList = row.transferOutboundPlanItemList;
              this.boxingList = row.transferOutboundPlanBoxItemList;
              this.modalProps.show = false;
            },
          },
        };
        return;
      }
    },
    cancel() {
      this.$router.push({ name: "allotInbound" });
      this.$emit("on-update");
    },
    /* reprocess(){
          this.operate = {
                show: true,
                alert: "error",
                title: "重处理",
                width: 400,
                showDesc: true,
                params: {
                    id:  this.id,
                    type:3
                },
				ajaxRequest: HttpReprocessPlanBill,
				callback: this.cancel
          };
    },
    backToNormal(){
          this.operate = {
                show: true,
                alert: "info",
                title: "忽略异常",
                width: 400,
                showDesc: true,
                params: {
                    id: this.id,
                    type:3
                },
				ajaxRequest: HttpBackToNormalPlanBill,
				callback: this.cancel
          };
    }, */
    //获取调拨计划单详情数据
    getTransferPlanDetail() {
      /* console.log(444)
			if (this.type !== 'edit') return;
			console.log(5555) */
      this.loading = true;
      HttpPlanBill({ id: this.formData.transferOutboundPlanId })
        .then((res) => {
          const body = res.data.transferOutboundPlanEntity || {};
          this.productList = body.transferOutboundPlanItemList || [];
          this.boxingList = body.transferOutboundPlanBoxItemList || [];
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    getDetail() {
      if (!this.getId) return;
      this.loading = true;
      HttpInbound({
        transferInboundId: this.getId,
      })
        .then((res) => {
          this.handleResponse(res.data);
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    handleResponse(data) {
      const body = data.transferInboundOrderEntity || {};
      const entity = data.transferOutboundPlanEntity || {};
      this.loading = false;
      this.dataList = body.transferInboundOrderItemEntityList || [];
      delete body.transferInboundOrderItemEntityList;
      this.formData = body;
      this.formData.subTransferPlanId = this.formData.transferOutboundPlanId;
      this.formData.transferOutboundPlanId = entity.id;
      this.logList = data.orderLogEntityList || [];
      this.getTransferPlanDetail();
    },
    async addItem() {
      const valid = await this.$refs.bound.validate();
      if (!valid) return;
      this.loading = true;
      HttpAddInbound({
        transferInboundOrderId: this.getId,
        transferOutboundPlanId: this.formData.transferOutboundPlanId,
        ...this.boundFormData,
      })
        .then((res) => {
          this.loading = false;
          this.getDetail();
          this.boundFormData = {};
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    clearAll() {
      this.modalProps2 = {
        show: true, //显示弹框
        width: 400, //弹框宽度
        alert: "success", //简洁模式主题和component模式互斥，
        params: { transferInboundOrderId: this.id }, //接口参数
        ajaxRequest: HttpClearInbound, //接口
        desc: this.$t("fbb.alloment.confirm_clear_all_data", {
          defaultValue: "是否确认清空所有数据？",
        }),
        //不显示描述，
        title: this.$t("global.common.clear", { defaultValue: "清空" }), //标题，
        callback: () => {
          this.getDetail();
        }, //成功回调函数,
      };

      /* 	this.loading = true;
			HttpClearInbound({
				transferInboundOrderId: this.getId
			}).then(res => {
				this.loading = false;
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			}) */
    },
    removeItems() {
      const ids = this.checkData.join(",");
      if (!ids) {
        this.$VMessage.warning(
          this.$t("global.common.choose_one", {
            defaultValue: "请选择至少一条数据",
          })
        );
        return;
      }
      this.loading = true;
      HttpRemoveInbound({
        ids: this.checkData.join(","),
        transferInboundOrderId: this.getId,
      })
        .then((res) => {
          this.loading = false;
          this.getDetail();
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    //提交完成
    submitComplete() {
      if (!this.dataList.length)
        return this.$VMessage.warning(
          this.$t("fbb.alloment.add_inbound_detail", {
            defaultValue: "请添加入库明细",
          })
        );
      this.loading = true;
      HttpSubmitInbound({
        transferInboundId: this.getId,
      })
        .then((res) => {
          this.loading = false;
          this.cancel();
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    async submitSave(type) {
      const valid = await this.$refs.formbase.validate();
      if (!valid) return;
      this.loading = true;
      // const data = {
      // 	transferOutboundPlanId: this.formData.transferOutboundPlanId,
      // 	remark: this.formData.remark || "",
      // 	id:this.getId
      // }
      const id = this.getId;
      HttpSaveInbound({
        subTransferPlanId: this.formData.subTransferPlanId,
        remark: this.formData.remark || "",
        id,
        labelQty: this.formData.labelQty,
      })
        .then((res) => {
          this.loading = false;
          HttpInbound({
            transferInboundId: res.data.id,
          })
            .then((res) => {
              this.handleResponse(res.data);
            })
            .catch((err) => {
              this.loading = false;
              this.$VMessage.error(err.message);
            });
          /* this.handleResponse({ transferInboundOrderEntity: res.data }); */
          if (type === "complete") return this.submitComplete();
          if (id) {
            this.$VMessage.success(
              `${this.$t("fbb.allotmant.inbound", {
                defaultValue: "调拨出库单",
              })}:${this.formData.transferInboundOrderNo}`
            );
            this.cancel();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    onceSubmit() {
      this.loading = true;
      HttpOnceInbound({
        transferOutboundPlanId: this.formData.transferOutboundPlanId,
        transferInboundId: this.getId,
        subTransferPlanId: this.formData.subTransferPlanId,
      })
        .then((res) => {
          this.loading = false;
          this.getDetail();
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
  },
};
</script>
